import { render, staticRenderFns } from "./DeliveryTimeByArea.vue?vue&type=template&id=6322f5a6&lang=pug&"
import script from "./DeliveryTimeByArea.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTimeByArea.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryTimeByArea.vue?vue&type=style&index=0&id=6322f5a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports